import React from 'react';
export function Footer() {
  return <footer className="bg-black text-white pt-24 pb-12 px-6" data-id="element-92">
      <div className="max-w-[1800px] mx-auto" data-id="element-93">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-24" data-id="element-94">
          <div className="md:col-span-1" data-id="element-95">
            <h2 className="text-2xl font-display font-bold tracking-[0.4em] uppercase mb-8" data-id="element-96">
              Djili
            </h2>
            <p className="text-[10px] font-display tracking-widest text-white/50 leading-loose" data-id="element-97">
              HIGH FASHION. <br data-id="element-98" />
              CULTURAL AUTHORITY. <br data-id="element-99" />
              MODERN HERITAGE.
            </p>
          </div>

          <div data-id="element-100">
            <h4 className="text-[10px] font-display uppercase tracking-[0.3em] mb-8 text-white/40" data-id="element-101">
              Studio
            </h4>
            <div className="space-y-4 text-[11px] font-light tracking-wider leading-relaxed" data-id="element-102">
              <p className="font-bold uppercase tracking-widest" data-id="element-103">
                Los Angeles Studio
              </p>
              <p data-id="element-104">4438 W Slauson Ave</p>
              <p data-id="element-105">Los Angeles, CA 90043</p>
              <a href="tel:5718423307" className="pt-4 text-white/60 block hover:text-white transition-colors" data-id="element-106">
                Text or Call: (571) 842-3307
              </a>
            </div>
          </div>

          <div data-id="element-107">
            <h4 className="text-[10px] font-display uppercase tracking-[0.3em] mb-8 text-white/40" data-id="element-108">
              Hours
            </h4>
            <div className="space-y-4 text-[11px] font-light tracking-wider leading-relaxed" data-id="element-109">
              <p data-id="element-110">Mon - Sat: 11AM - 6PM</p>
              <p data-id="element-111">Sunday: Closed</p>
              <p className="pt-4 text-white/60 italic font-display text-[9px] uppercase tracking-widest" data-id="element-112">
                By Appointment Only
              </p>
            </div>
          </div>

          <div data-id="element-113">
            <h4 className="text-[10px] font-display uppercase tracking-[0.3em] mb-8 text-white/40" data-id="element-114">
              Legal
            </h4>
            <ul className="space-y-4 text-[11px] font-light tracking-wider" data-id="element-115">
              <li data-id="element-116">
                <a href="#" className="hover:text-white/60 transition-colors" data-id="element-117">
                  Shipping & Returns
                </a>
              </li>
              <li data-id="element-118">
                <a href="#" className="hover:text-white/60 transition-colors" data-id="element-119">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-120">
                <a href="#" className="hover:text-white/60 transition-colors" data-id="element-121">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-122">
          <p className="text-[9px] font-display tracking-widest text-white/30 uppercase" data-id="element-123">
            © 2024 Djili Creations. All Rights Reserved.
          </p>
          <div className="flex space-x-8 text-[9px] font-display tracking-widest uppercase text-white/50" data-id="element-124">
            <a href="#" className="hover:text-white transition-colors" data-id="element-125">
              Instagram
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-126">
              Vogue
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-127">
              Pinterest
            </a>
          </div>
        </div>
      </div>
    </footer>;
}